import { canv } from '@/canv/global.js'
import { elementBase } from '@/elementBase/elementBase.js'
import { widgetOption } from '@/widgetMenu/widgetMenu';
import {
    getStringProperty,
    getNumberProperty,
    getColorProperty,
    isOnScreenAfterTranslate, logException
} from '@/canv/utils.js';
import { WIDTH_MULTIPLIER_FOR_HIGHLIGHTER } from '../constants';


export class sketchWidget extends elementBase {

    constructor() {
        super();
        this.updateDims();

        this.updateBase(this.startX, this.startY, this.width, this.height);
    }


    updateDims() {

        if (this.points.length < 2) {
            return;
        }

        var leftX = this.points[0]["x"];
        var rightX = this.points[0]["x"];
        var topY = this.points[0]["y"];
        var bottomY = this.points[0]["y"];

        for (var i = 0; i < this.points.length; i++) {
            leftX = this.points[i]["x"] < leftX ? this.points[i]["x"] : leftX;
            rightX = this.points[i]["x"] > rightX ? this.points[i]["x"] : rightX;
            topY = this.points[i]["y"] < topY ? this.points[i]["y"] : topY;
            bottomY = this.points[i]["y"] > bottomY ? this.points[i]["y"] : bottomY;
        }

        this.startX = leftX;
        this.startY = topY;
        this.width = rightX - leftX;
        this.height = bottomY - topY;

        this.calcControlPoints();

        this.updateBase(this.startX, this.startY, this.width, this.height);
    }

    calcControlPoints() {
        'use strict';

        var points = [];
        for (var i = 0; i < this.points.length; i++) {
            points.push([this.points[i]["x"], this.points[i]["y"]]);
        }

        // Default tension of one-quarter gives nice results
        var tension = 0.25;

        var l = points.length;

        if (l < 5) return;

        function h(x, y) {
            return Math.sqrt(x * x + y * y);
        }

        var cpoints = [];
        points.forEach(function() {
            cpoints.push({});
        });

        for (var i = 1; i < l - 1; i++) {
            var pi = points[i],     // current point
                pp = points[i - 1], // previous point
                pn = points[i + 1]; // next point;

            /* First, we calculate the normalized tangent slope vector (dx,dy).
             * We intentionally don't work with the derivative so we don't have
             * to handle the vertical line edge cases separately. */

            var rdx = pn[0] - pp[0],  // actual delta-x between previous and next points
                rdy = pn[1] - pp[1],  // actual delta-y between previous and next points
                rd = h(rdx, rdy),     // actual distance between previous and next points
                dx = rdx / rd,        // normalized delta-x (so the total distance is 1)
                dy = rdy / rd;        // normalized delta-y (so the total distance is 1)

            /* Next we calculate distances to previous and next points, so we
             * know how far out to put the control points on the tangents (tension).
             */

            var dp = h(pi[0] - pp[0], pi[1] - pp[1]), // distance to previous point
                dn = h(pi[0] - pn[0], pi[1] - pn[1]); // distance to next point

            /* Now we can calculate control points. Previous control point is
             * located on the tangent of the curve, with the distance between it
             * and the current point being a fraction of the distance between the
             * current point and the previous point. Analogous to next point. */

            var cpx = pi[0] - dx * dp * tension,
                cpy = pi[1] - dy * dp * tension,
                cnx = pi[0] + dx * dn * tension,
                cny = pi[1] + dy * dn * tension;

            cpoints[i] = {
                cp: [cpx, cpy], // previous control point
                cn: [cnx, cny], // next control point
           };

        }

        /* For the end points, we only need to calculate one control point.
         * Picking a point in the middle between the endpoint and the other's
         * control point seems to work well. */

        if (l == 2) {
            cpoints[0] = {
                cn: [points[0][0] + (points[1][0] - points[0][0]) / 2, points[0][1]],
            };
            cpoints[l - 1] = {
                cp: [points[0][0] + (points[1][0] - points[0][0]) / 2, points[1][1]],
            };
        } else {
            cpoints[0] = {
                cn: [ (points[0][0] + cpoints[1].cp[0]) / 2, (points[0][1] + cpoints[1].cp[1]) / 2 ],
            };
            cpoints[l - 1] = {
                cp: [ (points[l - 1][0] + cpoints[l - 2].cn[0]) / 2, (points[l - 1][1] + cpoints[l - 2].cn[1]) / 2 ],
            };
        }

        this.cpoints = cpoints;
    }





    // Draw

    draw() {

        if (this.color == "transparent") {
            return;
        }

        if (this.cpoints.length < this.points.length) {
            return;
        }

        canv.ctx.beginPath();

        var globalAlphaMem = canv.ctx.globalAlpha;
        canv.ctx.globalAlpha = 1;
        canv.ctx.lineWidth = this.lineWidth;
        canv.ctx.strokeStyle = this.color;
        canv.ctx.fillStyle = this.color;

        if (this.mode == "highlighter") {
            canv.ctx.globalAlpha = 0.3;
            canv.ctx.lineWidth *= WIDTH_MULTIPLIER_FOR_HIGHLIGHTER;
        }

        canv.ctx.moveTo(this.points[0]["x"], this.points[0]["y"]);

        for (var i = 1; i < this.points.length; i++) {
            if (this.points.length != this.cpoints.length) return;
            var p = this.points[i],
                cp = this.cpoints[i],
                cpp = this.cpoints[i - 1];

            canv.ctx.bezierCurveTo(cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p["x"], p["y"]);
        }

        canv.ctx.stroke();
        canv.ctx.closePath();

        canv.ctx.globalAlpha = globalAlphaMem;
    }


    // translate resize

    translate(x, y) {
        if (isOnScreenAfterTranslate(x, y, this)) {
          for (let i = 0; i < this.points.length; i++) {
            this.points[i]["x"] += x;
            this.points[i]["y"] += y;
          }
        }

        this.updateDims();
    }

    resize(x, y) {
        if (x === 0 && y === 0) return;
        if (this.width + x < 15 || this.height + y < 15) return;

        const scaleX = this.width !== 0 ? (this.width + x) / this.width : 1;
        const scaleY = this.height !== 0 ? (this.height + y) / this.height : 1;

        let scale;
        if (scaleX === 1 || scaleY === 1) { // случай когда тянем вбок в группе
            if (scaleX === 1) scale = scaleY;
            if (scaleY === 1) scale = scaleX;
        } else {
            scale = Math.min(scaleX, scaleY);
        }

        for (let i = 1; i < this.points.length; i++) {
            const relX = this.points[i].x - this.points[0].x;
            const relY = this.points[i].y - this.points[0].y;

            this.points[i].x = this.points[0].x + relX * scale;
            this.points[i].y = this.points[0].y + relY * scale;
        }

        this.updateDims();
    }




    // iss

    isInCircleArea(area) {
        for (var i = 1; i < this.points.length; i++) {
            if (this.points.length !== this.cpoints.length) return false;
            var p = this.points[i],
                cp = this.cpoints[i],
                cpp = this.cpoints[i - 1];

            var res = this.isIntersectBezierLineWithCircle(this.points[i-1]["x"], this.points[i-1]["y"], cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p["x"], p["y"], area);

            if (res) {
                return true;
            }
        }

        return false;
    }

    isIntersectBezierLineWithCircle(x1, y1, x2, y2, x3, y3, x4, y4, area) {
        var iterates = 1000;
        var step = 1 / iterates;
        for (var t = 0; t < 1; t += step) {
            var res = this.getBezierPoint(x1, y1, x2, y2, x3, y3, x4, y4, t);
            const distance = Math.sqrt(
                Math.pow(res['x'] - area['x'], 2) + Math.pow(res['y'] - area['y'], 2)
            );

            if (distance <= area['radius']) {
                return true;
            }
        }

        return false;
    }

    isInArea(area) {
        for (var i = 1; i < this.points.length; i++) {
            if (this.points.length != this.cpoints.length) return false;
            var p = this.points[i],
                cp = this.cpoints[i],
                cpp = this.cpoints[i - 1];

            var res = this.isIntersectBezierLine(this.points[i-1]["x"], this.points[i-1]["y"], cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p["x"], p["y"], area);

            if (res) {
                return true;
            }
        }

        return false;
    }

    isOver() {
        for (var i = 1; i < this.points.length; i++) {
            if (this.points.length != this.cpoints.length) return false;
            var p = this.points[i],
                cp = this.cpoints[i],
                cpp = this.cpoints[i - 1];

            var res = this.isOverBezierLine(this.points[i-1]["x"], this.points[i-1]["y"], cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p["x"], p["y"]);

            if (res) {
                return true;
            }
        }

        return false;
    }

    isOverBezierLine(x1, y1, x2, y2, x3, y3, x4, y4) {
        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;
        var y = pt.y;

        var iterates = 1000;
        var step = 1 / iterates;
        for (var t = 0; t < 1; t += step) {
            var res = this.getBezierPoint(x1, y1, x2, y2, x3, y3, x4, y4, t);
            var distance = Math.sqrt((res["x"] - x)*(res["x"] - x) + (res["y"] - y)*(res["y"] - y));
            if (distance <= this.lineWidth) {
                return true;
            }
        }

        return false;
    }

    isIntersectBezierLine(x1, y1, x2, y2, x3, y3, x4, y4, area) {

        var iterates = 1000;
        var step = 1 / iterates;
        for (var t = 0; t < 1; t += step) {
            var res = this.getBezierPoint(x1, y1, x2, y2, x3, y3, x4, y4, t);
            if (res["x"] > area["x"] && res["x"] < area["x"] + area["width"] && res["y"] > area["y"] && res["y"] < area["y"] + area["height"]) {
                return true;
            }
        }

        return false;
    }



    getBezierPoint(x1, y1, x2, y2, x3, y3, x4, y4, t = 0.5) {
        var result = {
            "x": 0,
            "y": 0
        };

        result["x"] = (1-t)*(1-t)*(1-t)*x1 + 3*(1-t)*(1-t)*t*x2 + 3*(1-t)*t*t*x3 + t*t*t*x4;
        result["y"] = (1-t)*(1-t)*(1-t)*y1 + 3*(1-t)*(1-t)*t*y2 + 3*(1-t)*t*t*y3 + t*t*t*y4;
        return result;
    }





    // Далее обработчики menu

    menuColor(color) {
        this.color = color;
        var penTool = canv.toolBox.TryGetToolByName("penTool");
        penTool.setColor(this.color);
    }

    menuWidth(value) {
        this.lineWidth = value;
        this.updateDims();
        var penTool = canv.toolBox.TryGetToolByName("penTool");
        penTool.setWidth(this.lineWidth);
    }

    getWidgetOptions() {
        var widgetOptions = [];
        widgetOptions.push(new widgetOption("color", this.color, this.UID));
        widgetOptions.push(new widgetOption("width", this.lineWidth, this.UID));

        return widgetOptions;
    }

    getHandlerForOption(name) {
        if (name == "color") {
            return this.menuColor;
        } else if (name == "width") {
            return this.menuWidth;
        }
    }






    // helpers

    extractPoints() {
        var res = [];
        for (var i = 0; i < this.points.length; i++) {
            var point = {};
            point["x"] = this.points[i]["x"];
            point["y"] = this.points[i]["y"];
            res.push(point);
        }

        return res;
    }

    loadPoints(points) {
        if (points == undefined) return;
        this.points = [];
        for (var i = 0; i < points.length; i++) {
            var newPoint = {
                "x": getNumberProperty("x", points[i]),
                "y": getNumberProperty("y", points[i]),
            };
            this.points.push(newPoint);
        }
    }




    // Далее для statesManager

    getFixType(reason) {
        var fixType = "full";

        switch (reason) {

            case "move":
                fixType = "move";
                break;
            case "resize":
                fixType = "resize";
                break;
            case "wm_color":
                fixType = "color";
                break;
            case "wm_width":
                fixType = "width";
                break;

        }

        return fixType;
    }

    getState(fixType) {
        var state = {};

        switch (fixType) {

            case "move":
                state["points"] = this.extractPoints();
                break;
            case "resize":
                state["points"] = this.extractPoints();
                break;
            case "color":
                state["color"] = this.color;
                break;
            case "width":
                state["lineWidth"] = this.lineWidth;
                break;
            case "full":
                state["UID"] = this.UID;
                state["parentUID"] = this.parentUID;
                state["entityType"] = "sketchWidget";
                state["color"] = this.color;
                state["points"] = this.extractPoints();
                state["lineWidth"] = this.lineWidth;
                state["mode"] = this.mode;
                break;

        }

        return state;
    }

    loadState(stateObj, fixType) {
        switch (fixType) {

            case "move":
                this.loadPoints(stateObj["points"]);
                break;
            case "resize":
                this.loadPoints(stateObj["points"]);
                break;
            case "color":
                this.color = getColorProperty("color", stateObj);
                break;
            case "width":
                this.lineWidth = getNumberProperty("lineWidth", stateObj);
                break;
            case "full":
                this.UID = getStringProperty("UID", stateObj);
                this.parentUID = getStringProperty("parentUID", stateObj);
                this.color = getColorProperty("color", stateObj);
                this.loadPoints(stateObj["points"]);
                this.lineWidth = getNumberProperty("lineWidth", stateObj);
                this.mode = getStringProperty("mode", stateObj);
                break;

        }

        if (this.lineWidth == 0) this.lineWidth = 1;

        this.updateDims();

    }



    constructorName = "sketch";
    startX = 0;
    startY = 0;
    width = 0;
    height = 0;
    points = [];
    cpoints = [];

    lineWidth = 1;
    color = "black";
    mode = "pen";

}
